import { render, staticRenderFns } from "./CharacterAttributeInput.vue?vue&type=template&id=4fbd46ab&lang=pug&"
import script from "./CharacterAttributeInput.vue?vue&type=script&lang=js&"
export * from "./CharacterAttributeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterAttributeInput.vue"
export default component.exports